import { connect } from 'react-redux'
import { showFilterModal } from '../../redux/product/product'
import sortBy from '../../actions/sortBy'
import ListerTools from '../../components/ListerTools/ListerTools'

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleShowFilterModalClick: () => {
      dispatch(showFilterModal())
    },
    handleSortByChange: sortBy
  }
}

export default connect(null, mapDispatchToProps)(ListerTools)
